// extracted by mini-css-extract-plugin
export default {"label":"GridItemText_label__JyGY8","labelRequire":"GridItemText_labelRequire__QGs-E"};